import { RootStateOrAny } from 'react-redux';
import { Action, Reducer } from 'redux';

const composeReducers = (
  ...reducers: Reducer[]
) => (
  state: RootStateOrAny,
  action: Action
) => reducers.reduce<RootStateOrAny>((acc, reducer) => reducer(acc, action), state);

export default composeReducers;
